export const CommunityEndpoints = {
  getCommunity: (id: number): string =>
    `${process.env.CONTENT_PLATFORM_API}/rest/v1/communities/${id}`,
  getCommunities: (): string => `${process.env.CONTENT_PLATFORM_API}/rest/v1/communities`,
  getGroupCommunities: (slug: string) =>
    `${process.env.CONTENT_PLATFORM_API}/rest/v1/communityGroupsWithCommunities/${slug}`,
  editCommunity: (id: number) =>
    `${process.env.CONTENT_PLATFORM_API}/rest/v1/communities/admin/${id}`
}
